import FilterDropdown from './woocommerce/archive/filter-dropdown';
import FilterPrice from './woocommerce/archive/filter-price';
import FilterWindow from './woocommerce/archive/filter-window';
import FiltersModal from './components/FiltersModal';
import OrderBy from './woocommerce/archive/orderby';
import Pagination from './woocommerce/archive/pagination';
import ResultCount from './woocommerce/archive/result-count';
import SortingWindow from './woocommerce/archive/sorting-window';
import lazyLoadImages from "./components/lazyLoad";

window.addEventListener('DOMContentLoaded', () => {
    //desktop
    new OrderBy().init();
    new Pagination().init();
    new FilterDropdown().init();
    new FilterPrice().init();
    //mobile
    new ResultCount().init();
    new FilterWindow().init();
    new SortingWindow().init();

    jQuery(document).on("ajaxComplete", lazyLoadImages);

    const filtersWrapper: HTMLElement | null = document.querySelector('.filters-inner');

    filtersWrapper && new FiltersModal(
        filtersWrapper,
        '.filters-toggler',
        '.close-filters'
    ).init();

})